var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-cell',{attrs:{"title":_vm.title,"is-link":_vm.isLink,"value":_vm.value,"to":_vm.to}}),_c('div',{staticClass:"van-cell-labelc"},[(_vm.showDivider)?_c('van-divider',{staticClass:"divider"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }